'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return typeof window === 'undefined' || !!window.SSRtest;
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/isServer.js
// module id = 475
// module chunks = 0